import { createServerFn } from "@tanstack/react-start";
import { getRequest, setResponseHeader } from "@tanstack/react-start/server";
import { auth } from "@/lib/auth";
import { evaluateClientFeatureFlags } from "./clientFeatureFlags.server";

export const getClientFeatureFlags = createServerFn({ method: "GET" }).handler(
  async () => {
    setResponseHeader("Cache-Control", "no-store");
    const session = await auth.api.getSession({
      headers: getRequest().headers,
    });
    return evaluateClientFeatureFlags(session?.user ?? null);
  },
);
